<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label class="textGray">Titulo</label>
          <input type="text" v-model="device.name" class="form-control" :disabled="!canAccess()" />
        </div>
        <div class="form-group">
          <label class="textGray">Descrição</label>
          <textarea v-model="device.description" class="form-control" :disabled="!canAccess()"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div v-for="(photo, index) in device.photos" v-bind:key="photo.id || index" class="col-6 photoDevice" style="max-width: 300px; height: auto; position: relative;">
        <img v-if="!photo.id" :src="photo" alt style="width: 100%; height: auto;"/>
        <template v-if="photo.id">
          <img
            :key="photoRetryKey(photo)"
            :src="photo.url"
            alt
            v-show="!isPhotoPending(photo.id) && !hasPhotoFailed(photo.id)"
            style="width: 100%; height: auto;"
            v-on:error="onPhotoError(photo.id)"
            v-on:load="onPhotoLoaded(photo.id)"
          />
          <div
            v-if="isPhotoPending(photo.id)"
            class="d-flex align-items-center justify-content-center"
            style="width: 100%; min-height: 120px; background-color: #f2f2f2; border-radius: 4px;"
          >
            <b-spinner small label="Carregando foto"></b-spinner>
          </div>
          <div v-if="hasPhotoFailed(photo.id)" class="text-center text-muted" style="font-size: 12px; padding: 12px;">
            Não foi possível carregar a foto. Recarregue a página em instantes.
          </div>
        </template>
        <button
          v-if="canAccess()"
          type="button"
          class="btn btn-danger btn-sm"
          title="Remover foto"
          style="position: absolute; top: 4px; right: 4px; border-radius: 50%;"
          :disabled="saving"
          v-on:click="removePhoto(index)"
        >
          <font-awesome-icon icon="times" />
        </button>
      </div>
      <div
        class="col-6 photoDevice"
        v-if="canAccess()"
        v-show="!device.photos || device.photos.length < 8"
      >
        <div class="noPhoto" v-on:click="openModal('photo-modal')">
          <font-awesome-icon icon="camera" />
        </div>
      </div>
    </div>
    <div class="row">
      <!-- "So e necessaria uma opcao. Situacao: conforme = Validado: Sim; Situacao: Nao
           conforme = Validado: Nao" - apontamento passado pelo Marlon em 14/08/2026.
           O select "Validado" saiu
           daqui; is_approved continua sendo gravado, derivado da situacao. -->
      <div class="col-6">
        <div class="form-group">
          <label class="textGray">Situação</label>
          <select v-model="device.situation" class="form-control" :disabled="!canAccess()" v-on:change="linkSituationToApproved()">
            <option value="Conforme">Conforme</option>
            <option value="Não Conforme">Não Conforme</option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="canAccess()">
      <div class="iconContainer w-100 h-100">
        <b-spinner label="Small Spinner" v-if="saving"></b-spinner>
        <button
          class="btn btn-danger"
          type="button"
          v-on:click="openModal('device-confirm-modal')"
        >
          Excluir
        </button>
        <button
          class="btn btn-success float-right"
          style="margin-left:16px"
          :disabled="saving"
          v-on:click="save()"
        ><span>Salvar <font-awesome-icon icon="save" /> </span></button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-padding">
        <b-alert v-show="alert" :variant="alert_type" show>{{alert_msg}}</b-alert>
      </div>
    </div>
    <b-modal ref="photo-modal" size="xl" title="Adicionar Imagem" @ok="saveImage()">
      <ImageEditor
        ref="imageEditor"
        :machine_id="machine_id"
        :selected-directory="'Fotos DVS'"
      ></ImageEditor>
      <img :src="tempImage" style="width: 100%; height: auto; margin-top: 20px;" class="image" />
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Salvar</template>
    </b-modal>
    <b-modal
      ref="device-confirm-modal"
      title="Remover Dispositivo"
      modal-ok="Confirmar"
      modal-cancel="Cancelar"
      @ok="deleteProtectionDevice()"
    >
      Deseja mesmo remover o dispositivo de segurança: 
      {{ device.name ? device.name :  'Novo dispositivo' }}
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Confirmar</template>
    </b-modal>
  </div>
</template>
<script>
import axios from "@/api/axios";
// import Vue from "vue";
import ImageEditor from "@/components/ImageEditor.vue";
import { canAccess } from "@/utils/canAccess";

export default {
  name: "protection-device",
  props: {
    device: {},
    dvs_id: String,
    machine_id: String,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ImageEditor
  },
  data() {
    return {
      tempImage: "",
      saving: false,
      alert: false,
      alert_type: "success",
      alert_msg: "Item salvo com sucesso",
      // Estado de retry por foto: o upload grava no bucket S3 original, mas a
      // exibição usa a URL do bucket de thumbnails, gerada por um Lambda de
      // forma assíncrona. Logo após salvar, o thumb pode ainda não existir -
      // por isso a foto tenta recarregar algumas vezes com backoff antes de
      // desistir.
      photoRetries: {}
    };
  },
  mounted() {
    // this.device.is_approved = this.device.is_approved ? "1" : 0;
  },
  watch: {
    alert: function() {
      const vm = this;
      setTimeout(() => {
        vm.alert = false;
      }, 3000);
    }
  },
  methods: {
    canAccess,
    save: function() {
      if (this.saving) {
        return false;
      }
      // Sem o select "Validado" na tela, is_approved passa a ser sempre derivado aqui -
      // o @change do select de situacao nao cobre um dispositivo antigo cuja situacao
      // ja estava gravada e nunca foi tocada nesta sessao.
      this.linkSituationToApproved();
      let imagesClean = [];
      if (this.device.id) {
        this.update();
        return true;
      }
      if (this.device.photos) {
        for (let i = 0; i < this.device.photos.length; i++) {
          let x = this.device.photos[i].split(",");
          imagesClean.push(x[1]);
        }
      }
      this.saving = true;
      axios
        .post(`${process.env.VUE_APP_API_HOST}/api/admin/protection-devices`, {
          name: this.device.name,
          description: this.device.description,
          is_approved: this.device.is_approved,
          situation: this.device.situation,
          security_validation_id: this.dvs_id,
          images: imagesClean
        })
        .then((response) => {
          // this.device = response.data;
          this.saving = false;
          this.alert_type = "success";
          this.alert_msg = "Item Salvo com sucesso";
          this.alert = true;
          this.$emit('saveProtectionDevice', response.data);
        })
        .catch(() => {
          this.alert_type = "warning";
          this.alert_msg = "Ocorreu um erro";
          this.alert = true;
          this.saving = false;
          this.warning = true;
            setTimeout(() => {
                this.alert = false;
              }, 3000);
        });
    },
    update: function(onError) {
      this.saving = true;
      this.linkSituationToApproved();
      let imagesClean = [];
      if (this.device.photos) {
        for (let i = 0; i < this.device.photos.length; i++) {
          if(!this.device.photos[i].id){
            let x = this.device.photos[i].split(",");
            imagesClean.push(x[1]);
          }
        }
      }
      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/protection-devices/` +
            this.device.id,
          {
            name: this.device.name,
            description: this.device.description,
            is_approved: this.device.is_approved,
            security_validation_id: this.dvs_id,
            user_id: localStorage.getItem("auth.user_id"),
            situation: this.device.situation,
            photos: this.device.photos,
            images: imagesClean
          }
        )
        .then(response => {
          // this.device = response.data;
          this.saving = false;
          this.alert_type = "success";
          this.alert_msg = "Item atualizado com sucesso";
          this.alert = true;
          this.$emit('saveProtectionDevice', response.data);
        })
        .catch(() => {
          this.alert_type = "warning";
          this.alert_msg = "Ocorreu um erro";
          this.alert = true;
          this.saving = false;
          this.warning = true;
          if (onError) {
            onError();
          }
        });
    },
    uploadImage: function(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.tempImage = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    linkSituationToApproved: function(){
      this.device.is_approved = this.device.situation == "Conforme" ? true : false;
    },
    getPhotoRetryState: function(photoId) {
      return this.photoRetries[photoId] || { attempts: 0, tick: 0, pending: false, failed: false };
    },
    photoRetryKey: function(photo) {
      return photo.id + "-" + this.getPhotoRetryState(photo.id).tick;
    },
    isPhotoPending: function(photoId) {
      return this.getPhotoRetryState(photoId).pending;
    },
    hasPhotoFailed: function(photoId) {
      return this.getPhotoRetryState(photoId).failed;
    },
    onPhotoLoaded: function(photoId) {
      if (this.photoRetries[photoId]) {
        const state = this.photoRetries[photoId];
        this.$set(this.photoRetries, photoId, { attempts: 0, tick: state.tick, pending: false, failed: false });
      }
    },
    onPhotoError: function(photoId) {
      const RETRY_DELAYS_MS = [2000, 4000, 8000];
      const current = this.getPhotoRetryState(photoId);
      if (current.attempts >= RETRY_DELAYS_MS.length) {
        this.$set(this.photoRetries, photoId, { ...current, pending: false, failed: true });
        return;
      }
      const delay = RETRY_DELAYS_MS[current.attempts];
      this.$set(this.photoRetries, photoId, { ...current, attempts: current.attempts + 1, pending: true });
      setTimeout(() => {
        const latest = this.getPhotoRetryState(photoId);
        this.$set(this.photoRetries, photoId, { ...latest, tick: latest.tick + 1 });
      }, delay);
    },
    saveImage: function() {
      this.tempImage = this.$refs.imageEditor.getImageEdit();
      if (!this.device.photos) {
        this.device.photos = [];
      }
      if (this.tempImage) {
        this.device.photos.push(this.tempImage);
        this.tempImage = null;
        // const vm = this;
        // Vue.nextTick(function() {
        //   Vue.set(vm.device, "photos", vm.data.images);
        // });
      } else {
        this.alert_type = "warning";
        this.alert_msg = "Selecione uma imagem antes de salvar";
        this.alert = true;
      }
    },
    openModal: function(modal) {
      if (modal === "photo-modal" && this.$refs.imageEditor) {
        this.$refs.imageEditor.resetCanvas();
      }
      this.$refs[modal].show();
    },
    removePhoto: function(index) {
      const photo = this.device.photos[index];
      this.device.photos.splice(index, 1);
      if (photo && photo.id && this.device.id) {
        this.update(() => {
          // Se o PUT falhar, a remoção não foi persistida - devolve a foto ao array
          // local na mesma posição para não deixar a UI divergente do servidor.
          this.device.photos.splice(index, 0, photo);
        });
      }
    },
    deleteProtectionDevice: function () {
      if (this.device.id) {
        axios
          .delete(
            `${process.env.VUE_APP_API_HOST}/api/admin/protection-devices/${this.device.id}`
          )
          .then(() => {
            this.$emit('deleteProtectionDevice');
          })
          .catch(() => {
          });
      } else {
        this.$emit('deleteProtectionDevice');
      }
    }
  }
};
</script>
